export default __webpack_public_path__ + "static/media/BOD Regular Meeting June 30, 2020.24009052.pdf";